<template>
    <div id="ag-grid-demo">
        <vx-card>

            <!-- Filter date -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Date</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <flat-pickr id="dtp-transaction-summary-datebegin" :config="configFromdatePicker" v-model="filter.date_begin" placeholder="Date begin" @on-change="onFromChange"/>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <flat-pickr id="dtp-transaction-summary-dateend" :config="configTodatePicker" v-model="filter.date_end" placeholder="Date end" @on-change="onToChange"/>
                </div>
            </div>

            <!-- Filter user -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>User</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-user" v-model="filter.user" placeholder="Select user" :options="users">
                    </v-select>
                </div>
            </div>

            <!-- filter device -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <v-select id="cbo-device" v-model="filter.device" placeholder="Select device" :options="devices">
                    </v-select>
                </div>
            </div>

            <!-- Button -->
            <div class="vx-row">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData(1,20)" class="mr-3 mb-2 float-left">Filter</vs-button>
                </div>
            </div>

        </vx-card>

        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="activityLogs"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :immutableData="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="limit"
                :suppressPaginationPanel="true"
                :enableCellTextSelection="true"
            >
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage"/>
        </vx-card>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import {url} from '@/configs/apiUrl'
import Axios from '@/global/AxiosCall';
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
    components: {
        flatPickr,
        AgGridVue,
        'v-select': vSelect,
    },
    data() {
        return {
            activityLogs: [],
            users: [],
            devices: [],
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            configFromdatePicker: {
                minDate: null,
                maxDate: null,
                dateFormat: 'Y-m-d',
            },
            configTodatePicker: {
                minDate: null,  
                dateFormat: 'Y-m-d',
            },
            filter : {
                user: {
                    email: ''
                },
                device: {
                    code : ''
                },
                date_begin : "",
                date_end : "",
            },
            defaultColDef: {
                resizable: true,
                suppressMenu: true
            },
            columnDefs: [
                {
                    headerName: "#",
                    field: "no",
                    width: 75
                },
                {
                    headerName: "User",
                    field: "useremail",
                    filter: true,
                },
                {
                    headerName: "Activity",
                    field: "activity",
                },
                {
                    headerName: "Device Code",
                    field: "devicecode",
                    filter: true
                },
                {
                    headerName: "Device Name",
                    field: "devicename",
                    filter: true
                },
                {
                    headerName: "Datetime",
                    field: "datetime",
                    filter: false
                },
            ],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 30,
            totalData: 1,
            activePage: 1
        }
    },
    watch: {
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.activePage = val
                this.fetchData(val, this.limit)
            }
        }
    },
    methods: {
        onFromChange(selectedDates, dateStr) {
            this.$set(this.configTodatePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr) {
            this.$set(this.configFromdatePicker, 'maxDate', dateStr);
        },
        danger(title, text){
            this.$vs.notify({
                title: title,
                text: text,
                color: "danger",
                position: "top-right"
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        fetchData(page, limit){
            this.openLoading()
            this.activityLogs = []
            this.limit = limit
            let offset = limit * (page - 1)
            this.filter.device = (this.filter.device == null) ? {code:''} : this.filter.device
            this.filter.user = (this.filter.user == null) ? {email:''} : this.filter.user
            Axios.Get(url.audit_trail.get_device_remote_activities + '?page=' + page + '&limit=' + limit + '&offset=' + offset + '&device_code=' + this.filter.device.code + '&user_email=' + this.filter.user.email + '&start_date=' + this.filter.date_begin + '&end_date=' + this.filter.date_end).then(resp => {
                this.$vs.loading.close()
                if(resp.status_code == 200){
                    for(let i = 0; i < resp.data.data.length;i++){
                        let log = resp.data.data[i].logdata
                        log.no = i+1
                        log.datetime = moment(log.datetime).format('YYYY-MM-DD HH:mm:ss')
                        this.activityLogs.push(log)
                    }
                    this.dataCount = resp.data.total
                    this.totalPage = resp.data.lastPage
                    this.totalData = resp.data.total
                } else {
                    this.danger("Error", resp.status_message)
                }
            }).catch(e => {
                this.$vs.loading.close()
                console.log(e)
                this.danger("Error", `Failed to retrieve data`)
            })
        },
        getUsers() {
            return new Promise((resolve, reject) => {
                Axios.Get(url.svd.user.list+"?page=1&limit=9999999999&role_group=aino").then(response => {
                    if (typeof response.message_code !== '2002'){
                        for(let user of response.data.data) {
                            user.label = user.username+'('+user.roles+') - '+user.email+' - '+user.merchant
                            this.users.push(user)
                        }
                    }
                    resolve(true)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        getDevices() {
            return new Promise((resolve, reject) => {
                Axios.Get(url.svd.device.combo).then(resp => {
                    if (typeof resp.data !== 'undefined'){
                        for(let device of resp.data) {
                            device.label = device.name+' - '+device.code+' - '+device.merchant_full_name
                            this.devices.push(device)
                        }
                    }
                    resolve(true)
                }).catch(e => {
                    reject(e)
                })
            })
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.getUsers()
        this.getDevices()
    }
}
</script>
<style scoped>
    .flatpickr-input {
        padding: .7rem;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #626262;
        width: 100%;
    }
</style>